export default {"src":"/_next/static/media/cucumber.d4335862.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};